// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1z00M","dragIcon":"Choice_dragIcon__37SZ1","left":"Choice_left__2JPt-","input":"Choice_input__2p_2Z"};